"use client";

import { queryOptions, useQuery } from "@tanstack/react-query";

import { getSession, type SessionResponse } from "@/lib/auth-api";

export const sessionQueryKey = ["session"] as const;
export const sessionQueryOptions = queryOptions<SessionResponse>({
  queryKey: sessionQueryKey,
  queryFn: getSession,
  retry: false,
  staleTime: 15_000,
});

export function useSession() {
  const query = useQuery(sessionQueryOptions);

  return {
    ...query,
    user: query.isError ? null : query.data?.user ?? null,
  };
}
